export default __webpack_public_path__ + "static/media/switch-account-header.18120015.svg";